import { baseBuild } from '@/core/services/network/config/baseBuild';
import type { AppDispatch } from '@/app/store/store';
import { PhysicalStoreAdapter } from '../infra/adapters/physicalStore.adapter';
import { createPhysicalStoreService } from '../application/services/PhysicalStoreService';

export function physicalStoreBuild(dispatch: AppDispatch) {
  return baseBuild(
    (d: AppDispatch) => new PhysicalStoreAdapter(d),
    (repo) => createPhysicalStoreService(repo),
    dispatch
  );
}
